/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
    ContactToJSONTyped,
} from './Contact';

/**
 * 
 * @export
 * @interface AddSavedContactRequest
 */
export interface AddSavedContactRequest {
    /**
     * 
     * @type {Contact}
     * @memberof AddSavedContactRequest
     */
    contact: Contact;
    /**
     * 
     * @type {string}
     * @memberof AddSavedContactRequest
     */
    savedLocationId: string;
    /**
     * 
     * @type {string}
     * @memberof AddSavedContactRequest
     */
    savedContactId: string;
}

/**
 * Check if a given object implements the AddSavedContactRequest interface.
 */
export function instanceOfAddSavedContactRequest(value: object): value is AddSavedContactRequest {
    if (!('contact' in value) || value['contact'] === undefined) return false;
    if (!('savedLocationId' in value) || value['savedLocationId'] === undefined) return false;
    if (!('savedContactId' in value) || value['savedContactId'] === undefined) return false;
    return true;
}

export function AddSavedContactRequestFromJSON(json: any): AddSavedContactRequest {
    return AddSavedContactRequestFromJSONTyped(json, false);
}

export function AddSavedContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddSavedContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contact': ContactFromJSON(json['contact']),
        'savedLocationId': json['savedLocationId'],
        'savedContactId': json['savedContactId'],
    };
}

  export function AddSavedContactRequestToJSON(json: any): AddSavedContactRequest {
      return AddSavedContactRequestToJSONTyped(json, false);
  }

  export function AddSavedContactRequestToJSONTyped(value?: AddSavedContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact': ContactToJSON(value['contact']),
        'savedLocationId': value['savedLocationId'],
        'savedContactId': value['savedContactId'],
    };
}

